"use client";
import {
  useLogo
} from "./chunk-QBECDAWT.mjs";
import {
  LogoFavicon
} from "./chunk-MTRTAWKC.mjs";
import {
  LogoFull
} from "./chunk-JVOL7WBG.mjs";
import {
  LogoMini
} from "./chunk-B3DSOSEZ.mjs";

// src/logo.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Logo = forwardRef((props, ref) => {
  const { getLogoProps, domRef, variant } = useLogo({ ...props, ref });
  switch (variant) {
    case "full":
      return /* @__PURE__ */ jsx(LogoFull, { ref: domRef, ...getLogoProps() });
    case "mini":
      return /* @__PURE__ */ jsx(LogoMini, { ref: domRef, ...getLogoProps() });
    case "favicon":
      return /* @__PURE__ */ jsx(LogoFavicon, { ref: domRef, ...getLogoProps() });
    default:
      return /* @__PURE__ */ jsx(LogoFull, { ref: domRef, ...getLogoProps() });
  }
});
Logo.displayName = "UI.Logo";
var logo_default = Logo;

export {
  logo_default
};
